import { FC } from 'react';
import * as React from 'react';

import { Container } from '@crehana/ui';
import Loadable from '@crehana/web/Loadable';

import DashboardErrorView from '@/views/UserDashboard/components/DashboardTemplate/DashboardErrorView';

import CourseListSkeleton from './components/CourseListSkeleton';
import { CoursesProps } from './types';

const LazyCourses: FC<React.PropsWithChildren<CoursesProps>> = props => (
  <Loadable
    Loader={
      <Container type="dashboard">
        <CourseListSkeleton />
      </Container>
    }
    ErrorFallback={
      <Container type="dashboard">
        <DashboardErrorView defaultConnectionError supportsDarkMode />
      </Container>
    }
    module={() =>
      import(/* webpackChunkName: "user-dashboard-courses" */ './Courses')
    }
    {...props}
  />
);

export default LazyCourses;
